const NAMESPACE = "USER_PREFERENCES";

export const ActionTypes = {
  GetUserPreferences: `${NAMESPACE}/GET_PREFERENCES`,
  SaveUserPreferences: `${NAMESPACE}/SAVE_PREFERENCES`,
};
